export const isUserAdmin = state => state.user.role === 'ADMIN'
export const isUserStoreAdmin = state => state.user.role === 'STORE_ADMIN'
export const isUserCP = state => state.user.role === 'CP'
export const isUserMerchandise = state => state.user.role === 'MERCH'
